"use strict"

import React, { forwardRef } from "react"

import ObservationPlot from "../../plotting/ObservationPlot"
import { exportCSVFromArray } from "../../data_export/ObservationExporter"
import { exportMultiRunObservationsObject } from "../../../../components/graphing/data_export/ObservationExporter"
import { ObservationPlotBaton } from "./ObservationPlotBaton"
import {
  getObservationPlotData,
  ObservationKeyWrapper,
  crossPlotProps,
  getCommentDataForRows,
} from "../ObservationPlotFactory"

export const MultiRunPlotFactory = (config) => ({
  Component: forwardRef((props, ref) => {
    return <ObservationPlot ref={ref} {...props} layers={props.graphKey} />
  }),

  Key: (props) => <ObservationKeyWrapper trendEditKey={"observations"} {...props} />,

  makePlotBaton: () => {
    return new ObservationPlotBaton(config)
  },

  getCrossPlotProps: (plotPropsArray = []) => {
    const combineCommentLists = (key) =>
      [].concat.apply(
        [],
        plotPropsArray.map((r) => r?.[key] || []),
      )

    let info = {}
    plotPropsArray &&
      plotPropsArray.forEach((arr) => {
        info[arr.id] = arr.observationAccessor
      })

    return {
      observationAccessors: info,
      crossRunActions: combineCommentLists("combinedActions"),
      ...crossPlotProps(plotPropsArray),
    }
  },

  ensureDataRequested: (run, force_reload = false, is_first_run = false) =>
    getObservationPlotData(config, "observations", run, force_reload, is_first_run),

  getExportCSVName: (exportBaseName) => {
    const supp_label = (config.title || "unknown").replace(/[\s:]/g, "_")
    return `${exportBaseName}_${
      supp_label === exportBaseName || config.title === exportBaseName ? "Export" : supp_label
    }.csv`
  },

  getCommentDataForRows: getCommentDataForRows,

  getDataForRows: (runs, timeExtractor, minTime, maxTime, viewerState, zoomRanges, tzString, intl = null) => {
    let observationTypesFlat = {}
    for (const series of runs.map((run) => run.observationTypesFlat)) {
      observationTypesFlat = { ...series, ...observationTypesFlat }
    }

    return exportMultiRunObservationsObject(
      timeExtractor,
      minTime,
      maxTime,
      runs,
      observationTypesFlat,
      config.observations,
      intl,
      config,
      false,
      tzString,
      false,
    )
  },

  makeExportCSV: (data) => exportCSVFromArray(data),
})

export default MultiRunPlotFactory
